import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AuthServices } from "../services/AuthServices";
import useUpdateOnboardingStatus from "../../../utils/hooks/useUpdateOnboardingStatus";

const CheckoutReturn = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = searchParams.get("session_id");
  const updateOnboardingStatus = useUpdateOnboardingStatus();

  const [status, setStatus] = useState("loading");
  const [message, setMessage] = useState("");
  const hasVerified = useRef(false);

  useEffect(() => {
    if (!sessionId || hasVerified.current) return;
    hasVerified.current = true;

    const verifySession = async () => {
      const response = await AuthServices.verifySubscriptionSession(sessionId);

      if (!response?.success) {
        throw new Error("Session verification failed");
      }

      const statusUpdate = await updateOnboardingStatus("subscription");
      if (!statusUpdate) {
        setMessage(
          "There was an issue updating your subscription status. If the problem persists please contact support",
        );
        return;
      }
      setStatus("success");
      setMessage("Subscription activated successfully!");
      setTimeout(() => {
        navigate("/register/account-setup");
      }, 3000);
    };

    verifySession();
  }, [sessionId, navigate]);

  return (
    <div className="checkout-return-container">
      {status === "loading" && (
        <div className="status-card loading">
          <h2>Finalizing your subscription...</h2>
          <p>Please wait while we confirm your payment.</p>
          <div className="spinner"></div>
        </div>
      )}

      {status === "success" && (
        <div className="status-card success">
          <h2>You're all set 🎉</h2>
          <p>{message}</p>
          <p>Redirecting you to your dashboard...</p>
        </div>
      )}

      {status === "error" && (
        <div className="status-card error">
          <h2>Something went wrong</h2>
          <p>{message}</p>
          <button onClick={() => navigate("/register/account-setup")}>
            Back to plans
          </button>
        </div>
      )}
    </div>
  );
};

export default CheckoutReturn;
